import { createSelector } from "reselect"
import { omit } from "lodash"

export const getData = props => props.data

export const getTotalData = createSelector(
  [getData],
  (data) => data
    .map(({ total, index, date }) => ({
      total,
      index,
      date,
    })),
)

export const getBreakdownData = createSelector(
  [getData],
  (data) => {
    return data.map(item => omit(item, "total"))
  },
)
